import React from "react";
import ErrorHandler from "../kit/ErrorHandler/ErrorHandler";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { 
      hasError: true, 
      error 
    };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });

    // You can also log the error to an error reporting service here
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: error.toString(),
        fatal: false
      });
    }
  }

  handleRetry = () => {
    // Reset error state
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null 
    });
    
    // If custom retry function provided, call it
    if (this.props.onRetry) {
      this.props.onRetry();
    }
  };

  render() {
    if (this.state.hasError) {
      // Create enhanced error object with more details
      const enhancedError = {
        ...this.state.error,
        componentStack: this.state.errorInfo?.componentStack,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      };

      return (
        <ErrorHandler
          error={enhancedError}
          title="Application Error"
          subtitle="The application encountered an unexpected error"
          onRetry={this.handleRetry}
          showReturnButton={true}
          customReturnPath={this.props.fallbackPath}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;